import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'
import React from 'react'
import { getPublicLayout } from '@public/components/PublicLayout'
import { HEADER_TYPE } from 'components/Header'
import { Flex } from 'components/Layout'
import { environment } from 'constants/environment'
import { SPACE } from 'Theme'

const stripePromise = loadStripe(environment.STRIPE_API_KEY)

const PaymentLayout: React.FC<React.PWC> = ({ children }) => (
  <Flex py={SPACE.PX_60} flexDirection="column">
    {children}
  </Flex>
)

export const getPaymentLayout = (page: React.ReactNode) =>
  getPublicLayout(
    <PaymentLayout>
      <Elements stripe={stripePromise}>{page}</Elements>
    </PaymentLayout>,
    { headerType: HEADER_TYPE.CHECKOUT }
  )
